<div *ngIf="isVisible" class="row-between form-field avc-field" [ngClass]="{'border-green': isFixedPrice}">
    <span class="field-title">Precio fijo (no replica el contrato madre)</span>

    <mat-slide-toggle (change)="onChange($event)" [checked]="isFixedPrice"></mat-slide-toggle>
</div>
